module.exports = __webpack_public_path__ + "img/hk_room_floorplan_12.092aa7b4.png";